import React, { useEffect, useState } from 'react';
import { makeStyles, useTheme } from '@mui/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Typography from "@mui/material/Typography";

const useStyles = makeStyles((theme) => ({
    checkBox: {
        minWidth: 0,
        '& label > span':{
            padding:theme.spacing(.5),
            '& svg':{
                width:'.8em',
                height:'.8em',
            },
        }
    },
    listItem: {
        paddingLeft: '30px',
        paddingTop: 0,
        paddingBottom: 0
    }
}));
export default function SelectFilter(props) {
    const classes = useStyles();
    return (
        <ListItem role={undefined} dense button className={classes.listItem}>
            <ListItemIcon className={classes.checkBox}>
            <FormControlLabel
                control={<Checkbox
                    onChange={props.onChange}
                    edge="start"
                    style={{color:"#fff"}}
                    checked={props.selectedItem.includes(props.item)}
                    disableRipple
                    inputProps={{ 'aria-labelledby': `checkbox-list-label-${props.index}` }}
                />}
                label={<Typography style={{color:"#fff"}} variant="caption">{props.Name}</Typography>}
            />
                
            </ListItemIcon>
            {/* <ListItemText id={`checkbox-list-label-${props.index}`} primary={<Typography variant="caption">{`${props.Name}`}</Typography>} /> */}
        </ListItem>
    )
}